var _defs, _polyline, _path, _rect;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHammerblock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 210.02 59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#0083e8;}.a,.b,.c{opacity:0.2;}.b{fill:#2b6eae;}.c{fill:#5badff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "hammer-block") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "a",
    points: "13.54 59 13.54 45 196.54 45 196.54 59"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2415,1133h-13.54a38.62,38.62,0,0,1,39-39h132a38.59,38.59,0,0,1,39,39H2598",
    transform: "translate(-2401.46 -1088)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 39.54,
    width: 131,
    height: 6
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHammerblock);
export default __webpack_public_path__ + "static/media/hammerblock.d890019f2df0bba0008dd53652056ab6.svg";
export { ForwardRef as ReactComponent };